import {
  GET_REGION,
  GET_ALL_REGIONS
} from 'src/store/mutation-types'

export default {
  [GET_REGION] (state, region) {
    state.region = region
  },
  [GET_ALL_REGIONS] (state, regions) {
    state.regions = regions
  }
}



// WEBPACK FOOTER //
// ./src/components/region/store/mutations.js